module.exports = __webpack_public_path__ + "img/zj4.0241bd16.png";